import React, { FC } from "react";

import { Container } from "@UI/Components/Container/Container";
import { Text } from "@UI/Components/Text/Text";
import { Bold } from "@UI/Components/Bold/Bold";
import { VStack, HStack, Stack } from "@UI/Components/Stack/Stack";
import { Box } from "@UI/Components/Box/Box";
import { Button } from "@UI/Components/Button/Button";
import { Icon } from "@UI/Components/Icon/Icon";
import { Star as StarIcon } from "@UI/Components/Icons/Star";
import { FooterLinksGrid } from "./FooterLinksGrid";

import { Copyright } from "../Copyright/Copyright";
import { RouterLink } from "@Libs/Router/Components/RouterLink/RouterLink";
import { SocialLinks } from "../SocialLinks/SocialLinks";
import { AppStoreLinks } from "../AppStoreLinks/AppStoreLinks";

import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";
import { FooterLeftLinks } from "./FooterLeftLinks";
import { FooterCenterLinks } from "./FooterCenterLinks";
import { FooterRightLinks } from "./FooterRightLinks";

export const Footer: FC = () => {
  const FooterSocialLinks = () => (
    <Stack
      alignItems="stretch"
      spacing="8"
      direction={{ base: "column", md: "row", lg: "column" }}
      width="full"
    >
      <Box flex="1 1 50%">
        <Bold marginBottom="5" as="p">
          <FormattedMessage {...messages.followUs} />
        </Bold>
        <SocialLinks />
      </Box>
      <Box flex="1 1 50%">
        <Bold marginBottom="5" as="p">
          <FormattedMessage {...messages.discoverOurMobileApplication} />
        </Bold>
        <AppStoreLinks />
      </Box>
    </Stack>
  );

  return (
    <Box borderTop="1px" borderColor="gray.200" as="footer" padding="unset">
      <Container
        paddingY="16"
        maxW="container.xl"
        borderColor="gray.200"
        borderBottomWidth="1px"
      >
        <FooterLinksGrid
          linksLeft={<FooterLeftLinks />}
          linksCenter={<FooterCenterLinks />}
          linksRight={<FooterRightLinks />}
          socialLinks={<FooterSocialLinks />}
        />
        <Stack
          spacing="3"
          flexWrap="wrap"
          direction={{ base: "column", md: "row" }}
          marginTop="8"
        >
          <Button
            colorScheme="seaGreen"
            as={RouterLink}
            route="REQUEST_SERVICE"
            reloadDocument
          >
            <FormattedMessage {...messages.iNeedAService} />
          </Button>
          <Button
            colorScheme="seaGreen"
            variant="outline"
            as={RouterLink}
            route="BECOME_SERVICE_PROVIDER"
            reloadDocument
          >
            <FormattedMessage {...messages.iWantToOfferMyServices} />
          </Button>
        </Stack>
      </Container>
      <Container paddingTop="16" paddingBottom="8" maxW="container.xl">
        <VStack textAlign="center" marginBottom="10">
          <HStack spacing="1">
            {[1, 2, 3, 4, 5].map((i) => (
              <Box key={i}>
                <Icon as={StarIcon} color="orange" width="5" height="5" />
              </Box>
            ))}
          </HStack>
          <Text fontSize="lg">
            <FormattedMessage
              {...messages.theCompanyIsEvaluatedXOutOfYByZMembers}
              values={{
                x: "4.91",
                y: "5",
                z: "4.404",
              }}
            />
          </Text>
        </VStack>
        <Box textAlign="center">
          <Copyright
            showCompanyName
            showIban
            showYears
            showTermsAndConditionsLink
            showSitemapLink
          />
        </Box>
      </Container>
    </Box>
  );
};
